import { useMutation } from '@tanstack/react-query';
import {
  create, update, updateMultiple, getAll,
} from '../requests/fileCommisionDeviations';

const KEY = 'fileCommisionDeviation';

const useCreate = () => useMutation({
  mutationKey: [KEY, 'create'],
  mutationFn: (data) => create(data),
});

const useUpdate = () => useMutation({
  mutationKey: [KEY, 'update'],
  mutationFn: (data) => update(data),
});

const useUpdateMultiple = () => useMutation({
  mutationKey: [KEY, 'updateMultiple'],
  mutationFn: (data) => updateMultiple(data),
});

const useGetAll = () => useMutation({
  mutationKey: [KEY, 'getAll'],
  mutationFn: (data) => getAll(data),
});

const fileCommisionDeviationMutations = {
  useCreate,
  useUpdate,
  useUpdateMultiple,
  useGetAll,
};

export default fileCommisionDeviationMutations;
